define('modules/editor/models/property_groups/form_conversion',['require','exports','module','./base'],function(require, exports, module) {
  "use strict";
  var BasePropertyGroup = require("./base");

  module.exports = BasePropertyGroup.extend({
    name: "form:conversion",
    editAllowed: false,
    properties: ["step", "executeConversion"]
  });

});

